import { render } from "./BaseSelect.vue?vue&type=template&id=37652bdc&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=37652bdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37652bdc"]])

export default __exports__